import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import t from "../lib/i18n";

/**
 * Calm password input with a soft show/hide toggle.
 * - Always preserves BeeNest tone (no harsh red states).
 * - Eye icon respects accessibility: aria-pressed, aria-label, focus-visible ring.
 */
export const PasswordField = ({
  label,
  value,
  onChange,
  required = false,
  minLength = 8,
  testId = "password-input",
  autoComplete = "new-password",
  language = "en",
  placeholder = "••••••••",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      {label && (
        <label className="block text-sm font-semibold mb-2 ml-2">{label}</label>
      )}
      <div className="relative">
        <input
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          minLength={minLength}
          className="w-full rounded-2xl px-5 py-3 pr-14 outline-none"
          style={{
            background: "var(--bn-surface-alt)",
            border: "2px solid var(--bn-border)",
          }}
          data-testid={testId}
          autoComplete={autoComplete}
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-full"
          style={{ background: "transparent", color: "var(--bn-text-secondary)" }}
          aria-pressed={visible}
          aria-label={visible ? t(language, "passwordHide") : t(language, "passwordShow")}
          title={visible ? t(language, "passwordHide") : t(language, "passwordShow")}
          data-testid={`${testId}-toggle`}
        >
          {visible ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
